import * as appConstant from "../../constants/appConstant";
import {
    filterDateComparator,
    formatCurrency,
    formatDate,
    formatDateAndTime,
    formatToPercentage,
    formatToPercentageWhenNotNull,
    roundOffToTwoDecimalPlaces
} from "../../utils/formatFunctions";
import {customDateTimeFilter, deSanitize, getDateComparator, getValueGetter, sortId} from "../../utils/util";

export const DATATABLE_COLUMNS = [
    {
        field: "id",
        headerName: appConstant.PLACEMENT_ID_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PLACEMENT_ID_TOOLTIP,
        comparator: sortId
    },
    {
        field: "placementname",
        headerName: appConstant.PLACEMENT_NAME,
        valueGetter: getValueGetter(deSanitize),
        suppressColumnsToolPanel: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PLACEMENT_NAME_TOOLTIP
    },
    {
        field: "startdate",
        headerName: appConstant.PLACEMENT_START_DATE_LABEL,
        hide: false,
        filter: customDateTimeFilter("startdate"),
        sort: 'asc',
        headerTooltip: appConstant.START_DATE_TIME_TOOLTIP,
        valueGetter: getValueGetter(formatDateAndTime),
        comparator: getDateComparator(appConstant.MMM_DD_YYYY_HH_MI_AM_PM)
    },
    {
        field: "enddate",
        headerName: appConstant.PLACEMENT_END_DATE_LABEL,
        hide: false,
        filter: customDateTimeFilter("enddate"),
        headerTooltip: appConstant.END_DATE_TIME_TOOLTIP,
        valueGetter: getValueGetter(formatDateAndTime),
        comparator: getDateComparator(appConstant.MMM_DD_YYYY_HH_MI_AM_PM)
    },
    {
        field: "advertisercompanyid",
        headerName: appConstant.ADVERTISER_CID_LABEL,
        hide: false,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.ADVERTISER_CID_TOOLTIP
    },
    {
        field: "advertisername",
        headerName: appConstant.ADVERTISER_NAME_LABEL,
        hide: false,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.ADVERTISER_NAME_TOOLTIP
    },
    {
        field: appConstant.STATUS,
        headerName: appConstant.PLACEMENT_STATUS_LABEL,
        hide: false,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PLACEMENT_STATUS_TOOLTIP
    },
    {
        field: "calendaryear",
        headerName: appConstant.CALENDAR_YEAR_LABEL,
        hide: true,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.CALENDAR_YEAR_TOOLTIP
    },
    {
        field: "calendarqtr",
        headerName: appConstant.CALENDAR_QTR_LABEL,
        hide: true,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.CALENDAR_QUARTER_TOOLTIP
    },
    {
        field: "calendarmonth",
        headerName: appConstant.CALENDAR_MONTH_LABEL,
        hide: true,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.CALENDAR_MONTH_TOOLTIP
    },
    {
        field: "calendarweek",
        headerName: appConstant.CALENDAR_WEEK_LABEL,
        hide: true,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.CALENDAR_WEEK_TOOLTIP
    },
    {
        field: "fiscalyear",
        headerName: appConstant.FISCAL_YEAR_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.FISCAL_YEAR_TOOLTIP
    },
    {
        field: "fiscalquarter",
        headerName: appConstant.FISCAL_QUARTER_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.FISCAL_QUARTER_TOOLTIP
    },
    {
        field: "fiscalmonth",
        headerName: appConstant.FISCAL_MONTH_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.FISCAL_MONTH_TOOLTIP
    },
    {
        field: "fiscalweek",
        headerName: appConstant.FISCAL_WEEK_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.FISCAL_WEEK_TOOLTIP
    },
    {
        field: "publishername",
        headerName: appConstant.PUBLISHER_NAME_LABEL,
        hide: false,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PUBLISHER_NAME_TOOLTIP
    },
    {
        field: "publishercompanyid",
        headerName: appConstant.PUBLISHER_CID_LABEL,
        hide: false,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.PUBLISHER_CID_TOOLTIP
    },
    {
        field: "publisherpropertyid",
        headerName: appConstant.PUBLISHER_PROPERTY_TEXT_FIELD,
        hide: false,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.PUBLISHER_PID_TOOLTIP
    },
    {
        field: "placementtype",
        headerName: appConstant.PLACEMENT_TYPE_LABEL,
        hide: false,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PLACEMENT_TYPE_TOOLTIP
    },
    {
        field: "performanceoriginalpublishercommission", headerName: appConstant.ORIGINAL_PUBLISHER_COMMISSION_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ORIGINAL_PUBLISHER_COMMISSION_TOOLTIP
    },
    {
        field: "performancenewpublishercommission",
        headerName: appConstant.NEW_PUBLISHER_COMMISSION_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.NEW_PUBLISHER_COMMISSION_TOOLTIP
    },
    {
        field: "performanceoriginalratecardflatfeeprice",
        headerName: appConstant.ORIGINAL_FLAT_FEE_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.ORIGINAL_FLAT_FEE_TOOLTIP
    },
    {
        field: "performancecjnegotiatedflatfeecost",
        headerName: appConstant.CJ_FLAT_FEE_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.CJ_FLAT_FEE_TOOLTIP
    },
    {
        field: "websiteurl",
        headerName: appConstant.WEBSITE_URL_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.WEBSITE_URL_TOOLTIP
    },
    {
        field: "propertytype",
        headerName: appConstant.PROPERTY_TYPE_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PROPERTY_TYPE_TOOLTIP
    },
    {
        field: "propertymodel",
        headerName: appConstant.PROPERTY_MODEL_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PROPERTY_MODEL_TOOLTIP
    },
    {
        field: "personalizedortargeted",
        headerName: appConstant.PERSONALIZED_TARGETED_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PLACEMENT_TARGETED_TOOLTIP
    },
    {
        field: "dynamicorstatic",
        headerName: appConstant.DYNAMIC_STATIC_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.DYNAMIC_STATIC_TOOLTIP
    },
    {
        field: "rankofplacement",
        headerName: appConstant.RANK_OR_SPOT_NUMBER_OF_PLACEMENT_TEXT_FIELD,
        hide: true,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.PLACEMENT_SPOT_TOOLTIP
    },
    {
        field: "event",
        headerName: appConstant.EVENTS_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.EVENTS_TOOLTIP
    },
    {
        field: "performancesendsizeexpecteduniquevalues",
        headerName: appConstant.SEND_SIZE_LABEL,
        hide: true,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.SEND_SIZE_TOOLTIP
    },
    {
        field: "packagename",
        headerName: appConstant.PACKAGE_NAME_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PACKAGE_NAME_TOOLTIP
    },
    {
        field: "neworcompedplacement",
        headerName: appConstant.NEW_OR_COMPED_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.NEW_OR_COMPED_TOOLTIP
    },
    {
        field: "vipcontent",
        headerName: appConstant.VIP_CONTENT_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.VIP_CONTENT_TOOLTIP
    },
    {
        field: "proposedofferuseddescription",
        headerName: appConstant.PROPOSED_OFFER_USED_DESCRIPTION_TEXT_FIELD,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PROPOSED_AD_COPY_TOOLTIP
    },
    {
        field: "performancesovbefore",
        headerName: appConstant.SOV_BEFORE_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.SOV_BEFORE_TOOLTIP
    },
    {
        field: "performanceactualsovafter",
        headerName: appConstant.ACTUAL_SOV_AFTER_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_SOV_AFTER_TOOLTIP
    },
    {
        field: "lastyearsactualrevenue",
        headerName: appConstant.LAST_YEAR_ACTUAL_REVENUE_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.LAST_YEAR_REV_FOR_SAME_DATES_TOOLTIP
    },
    {
        field: "lastyearsactualcommissions",
        headerName: appConstant.LAST_YEAR_ACTUAL_COMMISSION_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.LAST_YEAR_COMM_FOR_SAME_DATES_TOOLTIP
    },
    {
        field: "yoyquarterstartdatecurrentyear",
        headerName: appConstant.YOY_QUARTER_START_DATE_CURRENT_YEAR_LABEL,
        hide: true,
        filter: 'agDateColumnFilter',
        filterParams: {comparator: filterDateComparator},
        valueGetter: getValueGetter(formatDate),
        comparator: getDateComparator(appConstant.MMM_DD_YYYY),
        headerTooltip: appConstant.PAST_3_MOS_CURRENT_YEAR_START_DATE_TOOLTIP
    },
    {
        field: "yoyquarterenddatecurrentyear",
        headerName: appConstant.YOY_QUARTER_END_DATE_CURRENT_YEAR_LABEL,
        hide: true,
        filter: 'agDateColumnFilter',
        filterParams: {comparator: filterDateComparator},
        valueGetter: getValueGetter(formatDate),
        comparator: getDateComparator(appConstant.MMM_DD_YYYY),
        headerTooltip: appConstant.PAST_3_MOS_CURRENT_YEAR_END_DATE_TOOLTIP
    },
    {
        field: "yoyquarterstartdatelastyear",
        headerName: appConstant.YOY_QUARTER_START_DATE_LAST_YEAR_LABEL,
        hide: true,
        filter: 'agDateColumnFilter',
        filterParams: {comparator: filterDateComparator},
        valueGetter: getValueGetter(formatDate),
        comparator: getDateComparator(appConstant.MMM_DD_YYYY),
        headerTooltip: appConstant.PAST_3_MOS_LAST_YEAR_START_DATE_TOOLTIP
    },
    {
        field: "yoyquarterenddatelastyear", headerName: appConstant.YOY_QUARTER_END_DATE_LAST_YEAR_LABEL,
        hide: true,
        filter: 'agDateColumnFilter',
        filterParams: {comparator: filterDateComparator},
        valueGetter: getValueGetter(formatDate),
        comparator: getDateComparator(appConstant.MMM_DD_YYYY),
        headerTooltip: appConstant.PAST_3_MOS_LAST_YEAR_END_DATE_TOOLTIP
    },
    {
        field: "yearoveryearlastyearrevenue",
        headerName: appConstant.YOY_CALCULATION_LAST_YEAR_REVENUE_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PAST_3_MOS_LAST_YEAR_REVENUE_TOOLTIP
    },
    {
        field: "yearoveryearcurrentyearrevenue",
        headerName: appConstant.YOY_CALCULATION_CURRENT_YEAR_REVENUE_LABEL,
        valueFormatter: formatCurrency,
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        hide: true,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.PAST_3_MOS_CURRENT_YEAR_REVENUE_TOOLTIP
    },
    {
        field: "yearoveryearobserved",
        headerName: appConstant.YOY_OBSERVED_PERCENTAGE_LABEL,
        valueFormatter: formatToPercentageWhenNotNull,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PAST_3_MOS_YOY_OBSERVED_TOOLTIP
    },
    {
        field: "performanceyoygrowthtrendused",
        headerName: appConstant.YOY_GROWTH_TREND_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.YOY_GROWTH_TREND_TOOLTIP
    },
    {
        field: "performancepredictedplacementlift",
        headerName: appConstant.PRIOR_PLACEMENT_LIFT_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PRIOR_PLACEMENT_LIFT_TOOLTIP
    },
    {
        field: "performanceotherexpectedlift",
        headerName: appConstant.OTHER_EXPECTED_LIFT_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.OTHER_EXPECTED_LIFT_TOOLTIP
    },
    {
        field: "averagebaselinerevenue",
        headerName: appConstant.AVERAGE_DAILY_REVENUE_BASELINE_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.CUSTOM_BASELINE_TOOLTIP
    },
    {
        field: "isbaselinecalculated",
        headerName: appConstant.CALCULATED_BASELINE_USED_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.AUTO_CALCULATED_BASELINE_USED_TOOLTIP
    },
    {
        field: "projectedspendwithplacement",
        headerName: appConstant.PROJECTED_SPEND_WITH_PLACEMENT_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PROJECTED_SPEND_WITH_PLACEMENT_TOOLTIP
    },
    {
        field: "projectedspendwithoutplacement",
        headerName: appConstant.PROJECTED_SPEND_WITHOUT_PLACEMENT_LABEL,
        valueFormatter: formatCurrency,
        hide: true, filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PROJECTED_SPEND_WITHOUT_PLACEMENT_TOOLTIP
    },
    {
        field: "projectedrevenuewithplacement",
        headerName: appConstant.PROJECTED_REVENUE_WITH_PLACEMENT_LABEL,
        valueFormatter: formatCurrency,
        hide: true, filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PROJECTED_REVENUE_WITH_PLACEMENT_TOOLTIP
    },
    {
        field: "projectedrevenuewithoutplacement",
        headerName: appConstant.PROJECTED_REVENUE_WITHOUT_PLACEMENT_LABEL,
        valueFormatter: formatCurrency,
        hide: true, filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PROJECTED_REVENUE_WITHOUT_PLACEMENT_TOOLTIP
    },
    {
        field: "projectedreturnonadspend",
        headerName: appConstant.PROJECTED_ROAS_LABEL,
        valueFormatter: formatCurrency,
        hide: true, filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PROJECTED_ROAS_TOOLTIP
    },
    {
        field: "projectedincrementalrevenue",
        headerName: appConstant.PROJECTED_INCREMENTAL_REVENUE_LABEL,
        valueFormatter: formatCurrency,
        hide: true, filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PROJECTED_INCREMENTAL_REVENUE_TOOLTIP
    },
    {
        field: "projectedincrementalspend",
        headerName: appConstant.PROJECTED_INCREMENTAL_SPEND_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PROJECTED_INCREMENTAL_SPEND_TOOLTIP
    },
    {
        field: "projectedincrementalreturnonadspend",
        headerName: appConstant.PROJECTED_INCREMENTAL_ROAS_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.PROJECTED_INCREMENTAL_ROAS_TOOLTIP
    },
    {
        field: "actualrevenue",
        headerName: appConstant.ACTUAL_REVENUE_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_REVENUE_TOOLTIP
    },
    {
        field: "actualincrementalrevenue",
        headerName: appConstant.ACTUAL_INCREMENTAL_REVENUE_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_INCREMENTAL_REVENUE_TOOLTIP
    },
    {
        field: "actualtotalcommissions",
        headerName: appConstant.ACTUAL_TOTAL_COMMISSIONS_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_TOTAL_COMMISSIONS_TOOLTIP
    },
    {
        field: "actualtotalspend",
        headerName: appConstant.ACTUAL_TOTAL_SPEND_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_TOTAL_SPEND_TOOLTIP
    },
    {
        field: "actualincrementalspend",
        headerName: appConstant.ACTUAL_INCREMENTAL_SPEND_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_INCREMENTAL_SPEND_TOOLTIP
    },
    {
        field: "actualreturnonadspend",
        headerName: appConstant.ACTUAL_ROAS_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_ROAS_TOOLTIP
    },
    {
        field: "actualincrementalreturnonadspend",
        headerName: appConstant.ACTUAL_INCREMENTAL_ROAS_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_INCREMENTAL_ROAS_TOOLTIP
    },
    {
        field: "actualclicks",
        headerName: appConstant.ACTUAL_CLICKS_LABEL,
        hide: true,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.ACTUAL_CLICKS_TOOLTIP
    },
    {
        field: "actualrevenuepervisits",
        headerName: appConstant.ACTUAL_RPV_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_RPV_TOOLTIP
    },
    {
        field: "actualsales",
        headerName: appConstant.ACTUAL_SALES_LABEL,
        hide: true,
        filter: 'agNumberColumnFilter',
        headerTooltip: appConstant.ACTUAL_ACTION_COUNT_TOOLTIP
    },
    {
        field: "actualnumberofsalesgeneratedperclick",
        headerName: appConstant.ACTUAL_CR_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_CR_TOOLTIP
    },
    {
        field: "actualplacementlift",
        headerName: appConstant.ACTUAL_PLACEMENT_LIFT_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ACTUAL_PLACEMENT_LIFT_TOOLTIP
    },
    {
        field: "revenuedelta",
        headerName: appConstant.REVENUE_DELTA_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.REVENUE_DELTA_PROJECTED_ACTUALS_TOOLTIP
    },
    {
        field: "revenueaccuracy",
        headerName: appConstant.REVENUE_ACCURACY_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.REVENUE_ACCURACY_PROJECTED_ACTUALS_TOOLTIP
    },
    {
        field: "returnonadspendaccuracy",
        headerName: appConstant.ROAS_ACCURACY_LABEL,
        valueFormatter: formatToPercentage,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.ROAS_ACCURACY_PROJECTED_ACTUALS_TOOLTIP
    },
    {
        field: "bookingtieredoffer",
        headerName: appConstant.TIERED_OFFER_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.TIERED_OFFER_TOOLTIP
    },
    {
        field: "bookingoffertype",
        headerName: appConstant.OFFER_TYPE_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.OFFER_TYPE_TOOLTIP
    },
    {
        field: "bookingoffervalue",
        headerName: appConstant.OFFER_VALUE_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.OFFER_VALUE_TOOLTIP
    },
    {
        field: "bookingofferconditions",
        headerName: appConstant.OFFER_CONDITIONS_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.OFFER_CONDITIONS_TOOLTIP
    },
    {
        field: "bookingofferthreshold",
        headerName: appConstant.OFFER_THRESHOLD_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.OFFER_THRESHOLD_TOOLTIP
    },
    {
        field: "bookinglinkid",
        headerName: appConstant.LINK_ID_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.LINK_ID_TOOLTIP
    },
    {
        field: "bookingassetsneeded",
        headerName: appConstant.ASSETS_NEEDED_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.ASSETS_NEEDED_TOOLTIP
    },
    {
        field: "bookingassetduedate",
        headerName: appConstant.ASSET_DUE_DATE_LABEL,
        hide: true,
        filter: customDateTimeFilter("bookingassetduedate"),
        valueGetter: getValueGetter(formatDateAndTime),
        comparator: getDateComparator(appConstant.MMM_DD_YYYY_HH_MI_AM_PM),
        headerTooltip: appConstant.ASSET_DUE_DATE_TOOLTIP
    },
    {
        field: "bookingassetssenttoadvertiser",
        headerName: appConstant.ASSETS_SENT_BY_ADVERTISER_LABEL,
        hide: true,
        filter: customDateTimeFilter("bookingassetssenttoadvertiser"),
        valueGetter: getValueGetter(formatDateAndTime),
        comparator: getDateComparator(appConstant.MMM_DD_YYYY_HH_MI_AM_PM),
        headerTooltip: appConstant.ASSETS_SENT_BY_ADVERTISER_TOOLTIP
    },
    {
        field: "bookingcjmarketplaceinsertionordernumber",
        headerName: appConstant.CJ_MARKETPLACE_IO_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.CJ_MARKETPLACE_IO_TOOLTIP
    },
    {
        field: "bookingotherinsertionordernumber",
        headerName: appConstant.PUBLISHER_IO_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PUBLISHER_IO_TOOLTIP
    },
    {
        field: "bookinginsertionordersignedindicator",
        headerName: appConstant.IO_SIGNED_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.IO_SIGNED_TOOLTIP
    },
    {
        field: "bookingprogramtermdescription",
        headerName: appConstant.PROGRAM_TERM_DESCRIPTION_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PROGRAM_TERM_DESCRIPTION_TOOLTIP
    },
    {
        field: "bookingprogramtermname",
        headerName: appConstant.PROGRAM_TERM_NAME_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PROGRAM_TERM_NAME_TOOLTIP
    },
    {
        field: "bookingprogramtermspushedindicator",
        headerName: appConstant.PROGRAM_TERM_PUSHED_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PROGRAM_TERM_PUSHED_TOOLTIP
    },
    {
        field: "bookingcashbackorincentiveamountonsite",
        headerName: appConstant.CASHBACK_AMOUNT_ONSITE_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.CASHBACK_AMOUNT_ONSITE_TOOLTIP
    },
    {
        field: "bookinginvoicemonth",
        headerName: appConstant.CJ_INVOICE_MONTH_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.CJ_INVOICE_MONTH_TOOLTIP
    },
    {
        field: "publisherusedspecifiedlinkid",
        headerName: appConstant.PUBLISHER_USED_LINK_ID_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PUBLISHER_USED_LINK_ID_TOOLTIP
    },
    {
        field: "description",
        headerName: appConstant.OFFER_DESCRIPTION_TEXT_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.OFFER_DESCRIPTION_TEXT_TOOLTIP
    },
    {
        field: "wascorrectofferused",
        headerName: appConstant.CORRECT_OFFER_USED_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.CORRECT_OFFER_USED_TOOLTIP
    },
    {
        field: "screenshotlink",
        headerName: appConstant.PATH_TO_SAVED_EMAIL_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PATH_TO_SAVED_EMAIL_TOOLTIP
    },
    {
        field: "validationnotes",
        headerName: appConstant.VALIDATION_NOTES_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.VALIDATION_NOTES_TOOLTIP
    },
    {
        field: "paidincj",
        headerName: appConstant.PAID_IN_CJ_LABEL,
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PAID_IN_CJ_TOOLTIP
    },
    {
        field: "transactiondate",
        headerName: appConstant.PAYMENT_DATE_LABEL,
        hide: true,
        valueGetter: getValueGetter(formatDate),
        comparator: getDateComparator(appConstant.MMM_DD_YYYY),
        filter: 'agDateColumnFilter',
        filterParams: {comparator: filterDateComparator},
        headerTooltip: appConstant.PAYMENT_DATE_TOOLTIP
    },
    {
        field: "transactionid",
        headerName: appConstant.PAYMENT_OID_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PAYMENT_OID_TOOLTIP
    },
    {
        field: "amount",
        headerName: appConstant.AMOUNT_PAID_LABEL,
        valueFormatter: formatCurrency,
        hide: true,
        filter: 'agNumberColumnFilter',
        filterValueGetter: getValueGetter(roundOffToTwoDecimalPlaces),
        headerTooltip: appConstant.AMOUNT_PAID_TOOLTIP
    },
    {
        field: "notes",
        headerName: appConstant.PAYMENT_NOTES_LABEL,
        valueGetter: getValueGetter(deSanitize),
        hide: true,
        filter: 'agTextColumnFilter',
        headerTooltip: appConstant.PAYMENT_NOTES_TOOLTIP
    }
];